import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { ReactComponent as VialIcon } from './vial_grey.svg'

export default function Vial ({ ...props }) {
  return <SvgIcon component={VialIcon} {...props} viewBox="0 0 5 18" />
}
